export default class Modal {
  private triggerSelector: string
  private closeSelector: string
  private visibleClass: string

  constructor({
    triggerSelector = '.modal-trigger',
    closeSelector = '.modal-close',
    visibleClass = 'modal--visible'
  } = {}) {
    this.triggerSelector = triggerSelector
    this.closeSelector = closeSelector
    this.visibleClass = visibleClass
  }

  public init(): void {
    document.addEventListener('click', this.handleDocumentClick)
    document.addEventListener('keydown', this.handleKeydown)
  }

  private handleDocumentClick = (event: Event): void => {
    const target = event.target as HTMLElement

    const trigger = target.closest(this.triggerSelector)

    if (trigger) {
      event.preventDefault()

      const modalSelector = trigger.getAttribute('data-modal-target')

      if (!modalSelector) return

      this.open(modalSelector)

      return
    }

    const closeButton = target.closest(this.closeSelector)

    if (closeButton) {
      event.preventDefault()

      const modal = closeButton.closest('.modal')

      if (!modal) return

      this.closeElement(modal as HTMLElement)
    }
  }

  private handleKeydown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') return

    const visibleModal = document.querySelector(
      `.${this.visibleClass}`
    ) as HTMLElement | null

    if (!visibleModal) return

    this.closeElement(visibleModal)
  }

  public open(modalSelector: string): void {
    const modal = document.querySelector(modalSelector) as HTMLElement | null

    if (!modal) return

    modal.classList.add(this.visibleClass)

    document.body.classList.add('modal-open')
  }

  public close(modalSelector: string): void {
    const modal = document.querySelector(modalSelector) as HTMLElement | null

    if (!modal) return

    this.closeElement(modal)
  }

  private closeElement(modal: HTMLElement): void {
    modal.classList.remove(this.visibleClass)

    document.body.classList.remove('modal-open')
  }
}